
;(function () {
  if (window.deferEngineInit) return
  window.deferEngineInit = true
  window.__deferDebug = true
  var LAZY_TYPE = 'text/lazyload'
  var ORIG_TYPE = 'data-orig-type'

  var SKIP_REL = {
    canonical: 1, icon: 1, 'shortcut icon': 1, 'apple-touch-icon': 1,
    'apple-touch-icon-precomposed': 1, preconnect: 1, 'dns-prefetch': 1,
    preload: 1, modulepreload: 1, prefetch: 1, prerender: 1,
    alternate: 1, manifest: 1, next: 1, prev: 1, search: 1
  }

  var SKIP_SCRIPT_TYPE = {
    'application/ld+json': 1, 'application/json': 1, 'text/json': 1
  }

  var PRESETS = {
    theme: {
      enabled: true,
      whitelist: ['searchanise', 'stylesheet.css','jquery2-2-4.min.js', 'queries.css', 'minified.css', 'theme.js', 'navona' ],
      blockList: ['trekkie.storefront', 'connect.facebook', 'omnisnippet1', 'aspnetcdn', 'billease', '/shopifycloud/', 'standard-actions', 'loader_2.js', 'fontawesome', 'font-awesome', '/shop-js/', 'tncapp', 'zinrelo.com','cdn.subscribers.com', '/cdn.shopify.com/extensions/', '/storefront/assets/', '/checkout-web/assets/', 'sca-pp.css', 'herokuapp'],
      deferList: ['googletagmanager' ],
      assetList: ['/75/assets/', '/cdn/shop/files/'],
      assetSameOrigin: false,
      assets: 'defer',
      thirdParty: 'block',
      inlineScripts: 'patch',
      matchInlineContent: false,
      lazyImages: 15,
      eagerClass: 'lazypreload',
      iframes: true,
      styles: true,
      scripts: true,
      patchNatives: true
    },
    standard: {
      enabled: true,
      whitelist: ['searchanise', 'countdown-timer-bar-samita-109',  'jquery2-2-4.min.js', 'minified.css', 'stylesheet.css', 'searchserverapi1', 'aspnetcdn', 'billease', 'navona', 'lazysizes.bundle.min.js' ],
      blockList: [],
      deferList: ['cdn.paas3d.com', 'facebook', 'analytics.goog', '/checkout-web/assets/', '/storefront/assets/','googletagmanager', '/shopifycloud/', 'standard-actions', 'loader_2.js', 'fontawesome', 'font-awesome', '/shop-js/', 'tncapp', 'zinrelo.com','cdn.subscribers.com', '/cdn.shopify.com/extensions/', '/storefront/assets/', '/checkout-web/assets/', 'sca-pp.css', 'herokuapp'],
      assetList: ['/75/assets/', '/cdn/shop/files/'],
      assetSameOrigin: false,
      assets: 'load',
      thirdParty: 'defer',
      inlineScripts: 'patch',
      matchInlineContent: true,
      lazyImages: 20,
      eagerClass: 'lazypreload',
      iframes: true,
      styles: true,
      scripts: true,
      patchNatives: true
    }
  }

  var mode = window.__deferEnabledTheme ? 'theme' : 'standard'
  var config = Object.assign({}, PRESETS[mode], window.deferOverrides || {})
  window.deferConfig = config

  if (!config.enabled) return

  var imageCount = 0
  var origin = window.location.origin || ''

  function matchesList(str, list) {
    if (!str || !list || !list.length) return false
    for (var i = 0; i < list.length; i++) {
      if (str.indexOf(list[i]) !== -1) return true
    }
    return false
  }

  function isAsset(url) {
    if (matchesList(url, config.assetList)) return true
    return !!(config.assetSameOrigin && origin && url.indexOf(origin) === 0)
  }

  function getAction(url) {
    if (!url) return 'load'
    if (matchesList(url, config.whitelist)) return 'load'
    if (matchesList(url, config.blockList)) return 'block'
    if (matchesList(url, config.deferList)) return 'defer'
    if (isAsset(url)) return config.assets
    return config.thirdParty
  }

  function patchInline(el) {
    var code = el.textContent
    if (!code) return
    if (code.indexOf('asyncLoad') !== -1) {
      code = code
        .replace('if(window.attachEvent)', "document.addEventListener('asyncLazyLoad',function(){asyncLoad()});if(window.attachEvent)")
        .replaceAll(', asyncLoad', ', function(){}')
    }
    if (code.indexOf('PreviewBarInjector') !== -1 || code.indexOf('adminBarInjector') !== -1) {
      code = code.replace('DOMContentLoaded', 'loadBarInjector')
    }
    if (code !== el.textContent) el.textContent = code
  }

  function applyScript(el) {
    if (el.type === LAZY_TYPE) return
    if (SKIP_SCRIPT_TYPE[(el.type || '').toLowerCase()]) return

    var src = el.getAttribute('src')
    if (src) {
      var resolved = el.src || src
      var action = getAction(resolved)
      if (action === 'block') {
        el.setAttribute('data-blocked', resolved)
        el.removeAttribute('src')
      } else if (action === 'defer') {
        el.setAttribute('data-src', resolved)
        el.removeAttribute('src')
        if (el.type) el.setAttribute(ORIG_TYPE, el.type)
        el.type = LAZY_TYPE
      }
      return
    }

    patchInline(el)
    if (config.inlineScripts !== 'defer') return
    var code = el.textContent || ''
    if (config.matchInlineContent && matchesList(code, config.whitelist)) return
    if (matchesList(code, config.blockList)) {
      el.setAttribute('data-blocked', '')
      el.type = LAZY_TYPE
      return
    }
    if (el.type) el.setAttribute(ORIG_TYPE, el.type)
    el.type = LAZY_TYPE
  }

  function applyLink(el) {
    if (SKIP_REL[(el.getAttribute('rel') || '').toLowerCase()]) return
    var href = el.getAttribute('href')
    if (!href) return
    var resolved = el.href || href
    var action = getAction(resolved)
    if (action === 'block') {
      el.setAttribute('data-blocked', resolved)
      el.removeAttribute('href')
    } else if (action === 'defer') {
      el.setAttribute('data-href', resolved)
      el.removeAttribute('href')
    }
  }

  function applyIframe(el) {
    var src = el.getAttribute('src')
    if (!src) return
    var resolved = el.src || src
    if (matchesList(resolved, config.whitelist)) return
    el.setAttribute('loading', 'lazy')
    el.setAttribute('data-src', resolved)
    el.removeAttribute('src')
  }

  function applyImage(el) {
    if (!config.lazyImages) return
    var loadingAttr = el.getAttribute('loading')
    var isEager = loadingAttr === 'eager' ||
      el.getAttribute('fetchpriority') === 'high' ||
      el.classList.contains(config.eagerClass)
    if (!isEager && ++imageCount > config.lazyImages && !loadingAttr) {
      el.setAttribute('loading', 'lazy')
    }
  }

  function handle(el) {
    if (el.hasAttribute('data-optimizer')) return
    var tag = el.tagName
    if (tag === 'SCRIPT' && config.scripts) applyScript(el)
    else if (tag === 'LINK' && config.styles) applyLink(el)
    else if (tag === 'IFRAME' && config.iframes) applyIframe(el)
    else if (tag === 'IMG') applyImage(el)
  }

  function scan(node) {
    var type = node.nodeType
    if (type !== 1 && type !== 11) return
    if (type === 1) {
      var tag = node.tagName
      if (tag === 'SCRIPT' || tag === 'LINK' || tag === 'IFRAME' || tag === 'IMG') {
        handle(node)
        return
      }
      if (!node.firstElementChild) return
    }
    var found = node.querySelectorAll('script, link, iframe, img')
    for (var i = 0; i < found.length; i++) handle(found[i])
  }

  function guard(node) {
    if (!node) return
    try {
      scan(node)
    } catch (err) {
      if (window.__deferDebug) console.warn('[deferEngine]', err, node)
    }
  }

  var origAppendChild = Node.prototype.appendChild
  var origInsertBefore = Node.prototype.insertBefore
  var origReplaceChild = Node.prototype.replaceChild

  if (config.patchNatives) {
    Node.prototype.appendChild = function (node) {
      guard(node)
      return origAppendChild.call(this, node)
    }
    Node.prototype.insertBefore = function (node, ref) {
      guard(node)
      return origInsertBefore.call(this, node, ref)
    }
    Node.prototype.replaceChild = function (node, old) {
      guard(node)
      return origReplaceChild.call(this, node, old)
    }
  }

  window.themeDeferRestoreNatives = function () {
    Node.prototype.appendChild = origAppendChild
    Node.prototype.insertBefore = origInsertBefore
    Node.prototype.replaceChild = origReplaceChild
  }

  var pageOptimizer = new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes
      for (var j = 0; j < added.length; j++) guard(added[j])
    }
  })

  pageOptimizer.observe(document, { childList: true, subtree: true })
  window.pageOptimizer = pageOptimizer
})()